import {
  MailOutlined,
  UserOutlined,
  PhoneOutlined,
  UnlockOutlined,
  LockOutlined,
  MobileOutlined,
} from "@ant-design/icons";
import Icon from "@ant-design/icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Input, notification } from "antd";
import FormItem from "antd/es/form/FormItem";
import { Link, useNavigate } from "react-router-dom";
import { images } from "../assets";
import APIService from "../services/APIService";

export default function SignUpPage() {
  let navigate = useNavigate();

  // const { value: showPassword, handleToggleValue: handleTogglePassword } =
  //   useToggleValue();

  async function register(values) {
    const RESULT = await APIService.register(
      values.familyname,
      values.fullname,
      values.phone,
      values.email,
      values.password
    );
    if (RESULT) {
      // const infoContact = {
      //   name: RESULT.drug_store.name,
      //   token: RESULT.token,
      // };
      notification["success"]({
        message: "Đăng ký thành công.",
        // description: 'Quay lại trang chủ để đặt đơn hàng mới'
      });
      navigate("/");
    }
  }

  const onSignupFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSignUp = (values) => {
    console.log(values);
    // navigate('/')
    register(values);
  };
  const PhoneSvg = () => (
    <svg
      width="15"
      height="20"
      viewBox="0 0 15 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.14449 1H11.8494C13.0421 1 13.9939 1.95042 13.9939 3.12342V17.0766C13.9939 18.2502 13.0204 19.2 11.8494 19.2H3.14449C1.95177 19.2 1 18.2496 1 17.0766V3.12342C1 1.94975 1.97352 1 3.14449 1ZM11.8494 18.3677C12.576 18.3677 13.1616 17.7992 13.1616 17.0766V3.12342C13.1616 2.42084 12.575 1.83232 11.8494 1.83232H3.14449C2.41789 1.83232 1.83232 2.40074 1.83232 3.12342V17.0766C1.83232 17.7791 2.41888 18.3677 3.14449 18.3677H11.8494ZM3.14449 1.1H11.8494C12.9876 1.1 13.8939 2.00632 13.8939 3.12342V17.0766C13.8939 18.1937 12.9665 19.1 11.8494 19.1H3.14449C2.00632 19.1 1.1 18.1937 1.1 17.0766V3.12342C1.1 2.00632 2.0274 1.1 3.14449 1.1ZM11.8494 18.4677C12.6293 18.4677 13.2616 17.8564 13.2616 17.0766V3.12342C13.2616 2.36464 12.6293 1.73232 11.8494 1.73232H3.14449C2.36464 1.73232 1.73232 2.34356 1.73232 3.12342V17.0766C1.73232 17.8353 2.36464 18.4677 3.14449 18.4677H11.8494Z"
        fill="black"
        stroke="black"
        stroke-width="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.87319 3.00195H10.0793C10.3031 3.00195 10.4954 3.19427 10.4954 3.41811C10.4954 3.64196 10.3031 3.83427 10.0793 3.83427H4.87319C4.64934 3.83427 4.45703 3.64196 4.45703 3.41811C4.45703 3.19427 4.64934 3.00195 4.87319 3.00195ZM4.87319 3.10195H10.0793C10.2479 3.10195 10.3954 3.24949 10.3954 3.41811C10.3954 3.58673 10.2479 3.73427 10.0793 3.73427H4.87319C4.70457 3.73427 4.55703 3.58673 4.55703 3.41811C4.55703 3.24949 4.70457 3.10195 4.87319 3.10195Z"
        fill="black"
        stroke="black"
        stroke-width="0.2"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.33203 16.233C6.33203 15.61 6.83921 15.0791 7.48589 15.0791C8.12996 15.0791 8.63976 15.5863 8.63976 16.2119C8.63976 16.8349 8.13258 17.3658 7.48589 17.3658C7.18857 17.3658 6.88928 17.2521 6.67934 17.0432C6.44626 16.8324 6.33203 16.5309 6.33203 16.233ZM6.74819 16.9707C6.53742 16.781 6.43203 16.507 6.43203 16.233C6.43203 15.6639 6.89573 15.1791 7.48589 15.1791C8.07606 15.1791 8.53976 15.6428 8.53976 16.2119C8.53976 16.781 8.07606 17.2658 7.48589 17.2658C7.21189 17.2658 6.93789 17.1604 6.74819 16.9707ZM7.2826 16.4573C7.34875 16.5235 7.42894 16.5545 7.50697 16.5545C7.68359 16.5545 7.82852 16.4096 7.82852 16.233C7.82852 16.0563 7.68359 15.9114 7.50697 15.9114C7.33035 15.9114 7.18543 16.0563 7.18543 16.233C7.18543 16.311 7.21645 16.3912 7.2826 16.4573ZM7.21189 16.528C7.2962 16.6124 7.40159 16.6545 7.50697 16.6545C7.73882 16.6545 7.92852 16.4648 7.92852 16.233C7.92852 16.0011 7.73882 15.8114 7.50697 15.8114C7.27512 15.8114 7.08543 16.0011 7.08543 16.233C7.08543 16.3384 7.12758 16.4437 7.21189 16.528Z"
        fill="black"
        stroke="black"
        stroke-width="0.2"
      />
    </svg>
  );
  const PhoneIcon = (props) => <Icon component={PhoneSvg} {...props} />;
  return (
    <div className="flex flex-row w-screen h-full">
      <div className="flex flex-col items-center justify-center flex-3">
        <div className="w-[134px] h-[124px]">
          <img src={images.logoPNG} className="w-full h-full" alt="" />
        </div>
        <h2 className="text-xl font-black text-[#373737] not-italic">
          ĐĂNG KÝ
        </h2>
        <div className="flex flex-col gap-y-[12px]">
          <Form
            name="basic"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 24 }}
            onFinish={handleSignUp}
            onFinishFailed={onSignupFailed}
            autoComplete="off"
          >
            <div className="flex w-[495px] bg-[#F8F8F8] border-[0.5px] border-solid border-[#B8B8B8] mt-4 ">
              <div className="flex items-center justify-center border-r-[0.5px] border-[#B8B8B8] px-5">
                <UserOutlined
                  style={{ width: "16px", height: "12px", color: "#222222" }}
                />
              </div>
              <div className="flex flex-col w-full">
                <div className="pl-4 flex items-center py-3 border-b-[0.5px] border-[#B8B8B8]">
                  <label className="text-[#119AE2]" htmlFor="">
                    Họ
                  </label>
                  <span className="ml-1 text-sm font-normal text-red-500">
                    *
                  </span>
                </div>
                <div className=" flex py-1.5">
                  <Form.Item
                    className="w-full m-0"
                    name="familyname"
                    rules={[{ required: true, message: "Vui lòng nhập họ" }]}
                  >
                    <Input
                      bordered={false}
                      placeholder="Nhập họ"
                      className="text-sm font-semibold placeholder:italic"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="flex w-[495px] bg-[#F8F8F8] border-[0.5px] border-solid border-[#B8B8B8] mt-4 ">
              <div className="flex items-center justify-center border-r-[0.5px] border-[#B8B8B8] px-5">
                <UserOutlined
                  style={{ width: "16px", height: "12px", color: "#222222" }}
                />
              </div>
              <div className="flex flex-col w-full">
                <div className="pl-4 flex items-center py-3 border-b-[0.5px] border-[#B8B8B8]">
                  <label className="text-[#119AE2]" htmlFor="">
                    Tên
                  </label>
                  <span className="ml-1 text-sm font-normal text-red-500">
                    *
                  </span>
                </div>
                <div className=" flex py-1.5">
                  <Form.Item
                    className="w-full m-0"
                    name="fullname"
                    rules={[{ required: true, message: "Vui lòng nhập tên" }]}
                  >
                    <Input
                      bordered={false}
                      placeholder="Nhập tên"
                      className="text-sm font-semibold font-weight placeholder:italic"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="flex w-[495px] bg-[#F8F8F8] border-[0.5px] border-solid border-[#B8B8B8] mt-4 ">
              <div className="flex items-center justify-center border-r-[0.5px] border-[#B8B8B8] px-5">
                <PhoneIcon
                  style={{
                    width: "16px",
                    height: "12px",
                    color: "#222222",
                    position: "relative",
                  }}
                />
                {/* <FontAwesomeIcon icon="fa-regular fa-mobile-notch" className="w-4 h-3 color-[222222]" /> */}
              </div>
              <div className="flex flex-col w-full">
                <div className="pl-4 flex items-center py-3 border-b-[0.5px] border-[#B8B8B8]">
                  <label className="text-[#119AE2]" htmlFor="">
                    Số điện thoại
                  </label>
                  <span className="ml-1 text-sm font-normal text-red-500">
                    *
                  </span>
                </div>
                <div className=" flex py-1.5">
                  <Form.Item
                    className="w-full m-0"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập Số điện thoại đúng định dạng",
                        pattern: new RegExp(
                          /(84|0[3|5|7|8|9])+([0-9]{8,11})\b/g
                        ),
                      },
                    ]}
                  >
                    <Input
                      bordered={false}
                      placeholder="Nhập số điện thoại"
                      className="text-sm font-semibold font-weight placeholder:italic"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="flex w-[495px] bg-[#F8F8F8] border-[0.5px] border-solid border-[#B8B8B8] mt-4 ">
              <div className="flex items-center justify-center border-r-[0.5px] border-[#B8B8B8] px-5">
                <MailOutlined
                  style={{ width: "16px", height: "12px", color: "#222222" }}
                />
              </div>
              <div className="flex flex-col w-full">
                <div className="pl-4 flex items-center gap-[5px] py-3 border-b-[0.5px] border-[#B8B8B8]">
                  <label className="text-[#119AE2]" htmlFor="">
                    Email
                  </label>
                  <span className="text-sm font-normal text-red-500">*</span>
                  <span className="text-sm font-normal text-[10px] text-[#B8B8B8]">
                    ( điền thông tin để nhận hóa đơn điện tử )
                  </span>
                </div>
                <div className=" flex py-1.5">
                  <Form.Item
                    className="w-full m-0 "
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Email không đúng định dạng",
                        type: "email",
                        pattern: RegExp(
                          /^[a-z][a-z0-9_.]{5,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/gm
                        ),
                      },
                    ]}
                  >
                    <Input
                      bordered={false}
                      placeholder="Nhập email"
                      className="text-sm font-semibold font-weight placeholder:italic"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="flex w-[495px] bg-[#F8F8F8] border-[0.5px] border-solid border-[#B8B8B8] mt-4">
              <div className="flex items-center justify-center border-r-[0.5px] border-[#B8B8B8] px-5">
                <LockOutlined
                  style={{ width: "16px", height: "12px", color: "#222222" }}
                />
              </div>
              <div className="flex flex-col w-full">
                <div className="px-4 flex items-center py-3 border-b-[0.5px] border-[#B8B8B8]">
                  <label className="text-[#119AE2]" htmlFor="">
                    Mật khẩu
                  </label>
                  <span className="ml-1 text-sm font-normal text-red-500">
                    *
                  </span>
                </div>
                <div className=" flex py-1.5">
                  <Form.Item
                    className="w-full m-0"
                    name="password"
                    rules={[
                      { required: true, message: "Vui lòng nhập mật khẩu" },
                    ]}
                  >
                    <Input.Password
                      bordered={false}
                      placeholder="Nhập mật khẩu"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>
            <div className="text-right">
              <span className="inline-block text-sm font-normal cursor-pointer text-[#222222]">
                Quên mật khẩu
              </span>
            </div>
            <div className="flex justify-center text-white font-bold item-center my-[12px]">
              <button
                type="submit"
                className="w-[252px] h-[50px] p-2 rounded-[30px]  bg-[#119AE2]"
              >
                TẠO TÀI KHOẢN
              </button>
            </div>
          </Form>
        </div>
        <p className="mb-6 text-xs font-normal text-center lg:text-sm text-text3 lg:mb-8">
          Bạn đã có tài khoản{" "}
          <Link
            to="/signin"
            state={{ from: "signup" }}
            className="font-bold underline text-sm text-[#119AE2]"
          >
            Đăng nhập
          </Link>
        </p>
        <div className="w-[93px] h-[1px] bg-[#119AE2] mb-3"></div>
        <Link
          to="/"
          className="flex justify-center text-white font-bold item-center my-[12px]"
        >
          <button
            type="submit"
            className="sm:w-[252px] w-[181px] sm:h-[50px] p-2 rounded-[30px]  bg-[#7F4CEB]"
          >
            TIẾP TỤC MUA HÀNG
          </button>
        </Link>
      </div>
      <div className="singin flex flex-2 justify-center items-center flex-col gap-y-[29px]">
        <img
          src={images.bannersignup}
          className="object-cover w-full h-full bg-no-repeat bg-contain"
          alt=""
        />
        {/* <button className="w-[155px] h-[38px] p-2 rounded-[30px] bg-[#ffffff]">
          <Link
            className="text-base font-extrabold text-[#119AE2] not-italic capitalize "
            to="/contact"
          >
            Liên Hệ Ngay
          </Link>
        </button> */}
      </div>
    </div>
  );
}
